export const SUBMIT_CLINICAL_NOTES_SUCCESS = "SUBMIT_CLINICAL_NOTES_SUCCESS";
export const SUBMIT_DID_NOT_ATTEND_SUCCESS = "SUBMIT_DID_NOT_ATTEND_SUCCESS";
